import { InMemoryStorage } from './chunk-W7YKW4WJ.js';
import { v4 } from './chunk-CW6A3IUB.js';

// src/config.ts
var NULL_STORAGE = {
  clear: () => {
  },
  length: 0,
  getItem: () => null,
  key: () => null,
  removeItem: () => {
  },
  setItem: () => {
  }
};
var TRACKERID_KEY = "bytel_logger_trackerId";
var PrismeConfig = class _PrismeConfig {
  static DEFAULT_SEND_QUEUE_MAX_SIZE = 10;
  static DEFAULT_SEND_QUEUE_TIMEOUT_IN_MS = 1e4;
  st;
  urlEndpoint;
  environment;
  sendQueueTimeoutInMs;
  sendQueueMaxSize;
  trackerIdProvider;
  userInfoProvider;
  disableInput;
  additionalInputFilters;
  storageMethod;
  useAutoInstrumentation;
  ignoreUrls;
  authorizeUrls;
  constructor(partialConfig) {
    this.urlEndpoint = partialConfig.urlEndpoint;
    this.st = partialConfig.st;
    this.environment = {
      st: this.st,
      composant: partialConfig.composant,
      compte: partialConfig.compte,
      domaine: partialConfig.domaine,
      serveur: partialConfig.serveur,
      version: partialConfig.version,
      application: partialConfig.application || partialConfig.composant || this.st,
      nom: partialConfig.env
    };
    this.additionalInputFilters = partialConfig.additionalInputFilters || [];
    this.disableInput = !!partialConfig.disableInput;
    this.sendQueueMaxSize = partialConfig.sendQueueMaxSize || _PrismeConfig.DEFAULT_SEND_QUEUE_MAX_SIZE;
    this.sendQueueTimeoutInMs = partialConfig.sendQueueTimeoutInMs || _PrismeConfig.DEFAULT_SEND_QUEUE_TIMEOUT_IN_MS;
    if (partialConfig.storageMethod === null) {
      this.storageMethod = NULL_STORAGE;
    } else if (partialConfig.storageMethod === void 0) {
      this.storageMethod = typeof window !== "undefined" ? sessionStorage : new InMemoryStorage();
    } else {
      this.storageMethod = partialConfig.storageMethod;
    }
    this.trackerIdProvider = partialConfig.trackerIdProvider || this.getTrackerIdFromStorage;
    this.userInfoProvider = partialConfig.userInfoProvider || (() => ({}));
    this.useAutoInstrumentation = partialConfig.useAutoInstrumentation ?? false;
    this.ignoreUrls = partialConfig.ignoreUrls ? [...partialConfig.ignoreUrls, this.urlEndpoint] : [this.urlEndpoint];
    this.authorizeUrls = partialConfig.authorizeUrls;
  }
  getTrackerId() {
    return this.trackerIdProvider();
  }
  getTrackerIdFromCookie() {
    if (typeof window !== "undefined") {
      return document.cookie.split("; ").find((row) => row.startsWith(`${TRACKERID_KEY}=`))?.split("=")[1];
    }
  }
  getTrackerIdFromStorage() {
    let trackerId = this.getTrackerIdFromCookie() || this.storageMethod.getItem(TRACKERID_KEY);
    if (!trackerId) {
      trackerId = v4();
      this.storageMethod.setItem(TRACKERID_KEY, trackerId);
    }
    return trackerId;
  }
  setTrackerId(trackerId) {
    this.trackerIdProvider = () => trackerId;
  }
};

export { PrismeConfig, TRACKERID_KEY };
//# sourceMappingURL=chunk-KYJH4IVM.js.map
//# sourceMappingURL=chunk-KYJH4IVM.js.map